<template>
    <div>
        <az-break-title title="Empresas" />

        <div>
            <div class="row mb-3">
                <div class="col col-12 col-md-6">
                    <az-input icon="fas fa-search" v-model="search">
                        <template v-slot:buttonposb v-if="false">
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary" type="button" @click="copiar()">
                                    <i class="fas fa-copy"></i>
                                </button>
                            </div>
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button
                        type="button"
                        class="btn btn-outline-success"
                        @click="incluir ()">
                        Incluir
                    </button>
                </div>
            </div>
        </div>

        <az-empty-state v-if="!lista || !lista.length" icon="fa-solid fa-percent" />

        <div class="list-group mb-3 az-anime-surgir mb-3">
            <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                <span>
                    <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                        {{ dado.search }}
                    </a>
                </span>
                <span class="d-flex">
                    <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                        <input
                        type="checkbox"
                        class="custom-control-input"
                        :id="'ativo-' + id"
                        v-model="dado.fl_ativo"
                        @change="toggle(dado)"
                        />
                        <label class="custom-control-label" :for="'ativo-' + id"></label>
                    </div>
                </span>
            </li>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="editarModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">Empresa {{ item.id_empresa_operadora ? '#' + item.id_empresa_operadora : 'Nova' }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Nome"
                                    required
                                    :validate="validate"
                                    v-model="item.st_nome" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Razão Social"
                                    required
                                    :validate="validate"
                                    v-model="item.empresa.st_razao_social" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="CNPJ"
                                    type="cnpj"
                                    required
                                    :validate="validate"
                                    v-model="item.empresa.st_cnpj" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Inscrição Municipal"
                                    :validate="validate"
                                    v-model="item.empresa.st_inscricao_municipal" />
                            </div>
                        </div>

                        <cadastro-endereco v-model="item.empresa.endereco" :validate="validate" />

                        <!-- Telefones -->
                        <!-- <az-sub-title class="mt-3" title="Telefones" />
                        <cadastro-telefones v-model="item.empresa.telefone_empresas" :validate="validate" /> -->

                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button v-if="item && item.id_empresa_operadora" model="empresaOperadora" :id="item.id_empresa_operadora" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">{{ item.id_empresa_operadora ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzBreakTitle from "../../../util/AzBreakTitle.vue";
import AzEmptyState from "../../../util/AzEmptyState.vue";
import AzInput from "../../../shared/forms/AzInput.vue";
import AzSubmit from "../../../util/AzSubmit.vue";
import AzAuditLogButton from '../../../util/AzAuditLogButton.vue';
import CadastroEndereco from '../../../shared/CadastroEndereco.vue';

export default {
    data() { 
        return { 
            dados: null, 
            search: "", 
            item: null, 
            validate: false, 
            viewMode: "A",
        }
    },

    computed: {
        lista: {
            get() {
                let pesquisar = this.search.trim();
                let parts = pesquisar.replace(" ", ".*");
                let match = parts;
                let reg = new RegExp(match, "i");

                return this.dados && this.dados.length
                ? this.dados.filter(item => this.viewMode == 'T' || item.fl_ativo)
                    .filter(item => {
                        return !this.search || reg.test(JSON.stringify(item));
                    })
                : null;
            },
            set(newLista) {
                this.dados = newLista;
            }
        }
    },

    props: ['id_operadora', 'operadoras'],

    components: { 
        AzBreakTitle, 
        AzEmptyState,
        AzInput,
        AzSubmit,
        AzAuditLogButton,
        CadastroEndereco,
    },

    methods: { 
        copiar() { 
            this.$refs.copiador.copiar();
        },

        incluir() { 
            this.validate = false;
            this.item = null; 

            this.$nextTick(() => { 
                this.item = {
                    id_empresa_operadora: null,
                    st_nome: "",
                    id_operadora: this.id_operadora,
                    fl_ativo: true,
                    empresa: {
                        st_razao_social: "",
                        st_cnpj: "",
                        endereco: {
                            st_logradouro: '',
                            st_complemento: '',
                            st_bairro: '',
                            st_numero: '',
                            in_cep: ''
                        },
                    }
                };

                $("#editarModal").modal("show");
            });
        },

        editar(item) { 
            this.validate = false;
            this.item = null;

            this.$nextTick(() => { 
                this.item = _.cloneDeep(item);
                $('#editarModal').modal('show');
            });
        },

        load() { 
            this.$util.load(this, { 
                service: 'empresa_operadoras',
                parms: { 
                    where: { id_operadora: this.id_operadora },
                }
            });
        },

        toggle(item) {
            this.$util.toggle(this, { 
                service: 'empresa_operadoras',
                dados: item, 
            });
        },

        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'empresa_operadoras',
                dados: this.item, 
                modal: 'editarModal',
                reload: true, 
            });
        }
    },

    mounted() { 
        this.load(); 
    }

}
</script>
